// Generate a short UUID-like 7-character string by using
// Math.random to create a random number, converting it to base 36, and slicing it
export const generateShortUUID = (): string => {
  return Math.random().toString(36).substring(2, 9)
}
